import gsap from 'gsap'

const defaults = {
    ease: 'expo',
    stagger: 0.1,
    duration: 1.5,
}


const isArrayOrString = el => Array.isArray(el) || typeof el == 'string'

export class Parallax {

    static getElems({ delta, slides, currentSlide, elems }) {
        const slideToText = delta < 0 ? "-100vw" : "100vw"
        const elemsTranform = 4.0 * ((slides.length - currentSlide) - slides.length / 2)        
        const slideToElems = (elemsTranform) + 'vw'
        const [slideCopy, slideElems] = elems

        return [
            { slideCopy, slideToText },
            { slideElems, slideToElems },
        ]
    }

    static set({ slideCopy }, { slideElems = null, slideToElems = 0 }) {
        const timeline = gsap.timeline({ defaults })

        timeline.set(slideCopy, {
            autoAlpha: 1,
            x: 0
        })
        
        if ( !isArrayOrString(slideElems) ) return;

        timeline.set(slideElems, {
            x: slideToElems
        }, '-=1.25')
    }

    static fromTo({ slideCopy, slideToText }, { slideElems = null, slideToElems = 0 }) {
        const timeline = gsap.timeline({ defaults })

        timeline.fromTo(slideCopy, {
            autoAlpha: 0,
            x: slideToText
        }, {
            autoAlpha: 1,
            x: 0
        })
        
        if ( !isArrayOrString(slideElems) ) return;

        timeline.to(slideElems, {
            stagger: 0,
            x: slideToElems
        }, '-=1.25')
    }
}